import { ActionTree } from 'vuex';
import {
  ECreateResourceAction,
  ECreateResourceMutation,
  state as defaultState,
} from '@/content-library/create-resource/store/create-resource.constants';
import { ICreateResourceState } from '@/content-library/create-resource/store/create-resource.types';
import { RootState } from '@/store/store';
import { ResourceService } from '@/api/resources/services/resource.service';
import { IResource } from '@/api/resources/types/resource';
import { ICreateResourceDTO } from '@/api/resources/dtos/create-resource-dto';
import { IUpdateResourceDTO } from '@/api/resources/dtos/update-resource-dto';

export const actions: ActionTree<ICreateResourceState, RootState> = {
  [ECreateResourceAction.UpdateDraft]({ commit, state }, payload: Partial<IResource>) {
    const updatedResource: IResource = { ...state.draft, ...payload };
    commit(ECreateResourceMutation.SetDraft, updatedResource);
  },
  async [ECreateResourceAction.Create]({ commit, dispatch }, payload: ICreateResourceDTO) {
    commit(ECreateResourceMutation.SetSaving, true);
    try {
      const resource: IResource = await ResourceService.create(payload);
      dispatch(ECreateResourceAction.CreateSuccess, resource);
    } catch {
      dispatch(ECreateResourceAction.CreateFailed);
    }
  },
  [ECreateResourceAction.CreateSuccess]({ commit }, resource: IResource) {
    commit(ECreateResourceMutation.SetSavedResource, resource);
    commit(ECreateResourceMutation.SetSaving, false);
  },
  [ECreateResourceAction.CreateFailed]({ commit }) {
    commit(ECreateResourceMutation.SetSaving, false);
  },
  async [ECreateResourceAction.Update]({ commit, dispatch }, payload: IUpdateResourceDTO) {
    commit(ECreateResourceMutation.SetSaving, true);
    try {
      const updatedResource: IResource = await ResourceService.update(payload);
      dispatch(ECreateResourceAction.UpdateSuccess, updatedResource);
    } catch (error) {
      dispatch(ECreateResourceAction.UpdateFailed);
    }
  },
  [ECreateResourceAction.UpdateSuccess]({ commit }, resource: IResource) {
    commit(ECreateResourceMutation.SetSavedResource, resource);
    commit(ECreateResourceMutation.SetSaving, false);
  },
  [ECreateResourceAction.UpdateFailed]({ commit }) {
    commit(ECreateResourceMutation.SetSaving, false);
  },
  [ECreateResourceAction.ResetState]({ commit }) {
    commit(ECreateResourceMutation.SetState, defaultState);
  },
  [ECreateResourceAction.SetLoadingFlags](
    { commit },
    { loading, loaded }: { loading: boolean; loaded: boolean }
  ) {
    commit(ECreateResourceMutation.SetLoading, loading);
    commit(ECreateResourceMutation.SetLoaded, loaded);
  },
};
